module.exports = __webpack_public_path__ + "static/media/Z.2607b18c.svg";